import { configureStore } from "@reduxjs/toolkit";

import editKnowledgeReducer from "../features/editKnowledge/editKnowledgeReducer";
import AIReducer from "../features/AIIntelligent/AIReducer";
import AIReducerV7 from "../features/AIIntelligentV7/AIReducer";

const store = configureStore({
  reducer: {
    editKnowledge: editKnowledgeReducer,
    AIModal:AIReducer,
    AIReducerV7: AIReducerV7
  },
});

export default store;
